import { ArrowDown, ArrowUp } from "lucide-react";
import { fmtVal } from "@/lib/records";
import { fmtDateTime } from "@/lib/fmt";

const META = { updated_at: "Updated", created_at: "Created" };

export default function RecordsTable({ rows, columns, fields, sort, dir, onSort, onOpen, loading }) {
  const label = (k) => META[k] || fields.find((f) => f.key === k)?.label || k;
  const cell = (r, k) => (META[k] ? fmtDateTime(r[k]) : fmtVal(r.data?.[k]));
  return (
    <div className="panel rounded-b-none overflow-x-auto" data-testid="records-table">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-[11px] uppercase tracking-wider text-[var(--text-dim)] border-b border-[var(--border)]">
            {columns.map((k) => (
              <th key={k} className="px-3 py-2 font-normal whitespace-nowrap">
                <button className="inline-flex items-center gap-1 hover:text-[var(--text)]" onClick={() => onSort(k)} data-testid={`records-sort-${k}`}>
                  {label(k)}{sort === k && (dir === "asc" ? <ArrowUp size={11} /> : <ArrowDown size={11} />)}
                </button>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={loading ? "opacity-50" : ""}>
          {rows.map((r) => (
            <tr key={r._id} className="border-b border-[var(--border)] hover:bg-[var(--hover)] cursor-pointer" onClick={() => onOpen(r)} data-testid={`record-row-${r._id}`}>
              {columns.map((k) => <td key={k} className="px-3 py-2 max-w-[320px] truncate" title={cell(r, k)}>{cell(r, k) || <span className="text-[var(--text-faint)]">—</span>}</td>)}
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={columns.length} className="px-3 py-10 text-center text-[var(--text-dim)]" data-testid="records-empty">{loading ? "Loading…" : "No records match."}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
